import {
  CreateGHADiscountRuleBody,
  CreateGHADiscountRuleDiscountType,
  GHADiscountRule,
  GHADiscountRuleAccountType,
  GHADiscountRuleDiscountType,
} from '~/services/ConnectionGoogleService';
import { formatDateWithClock } from '~/services/TimeService';

import { GHA_DISCOUNT_ACCOUNT_TYPE_OPTIONS } from './constants';

export type GHADiscountRuleFormState = {
  propertyId: string;
  accountType?: GHADiscountRuleAccountType;
  discountType: CreateGHADiscountRuleDiscountType;
  discountValue: string;
  minAdvanceBookingWindow: string;
  minLengthOfStay: string;
};

export function toCreateGHADiscountRuleBody(
  form: GHADiscountRuleFormState & { accountType: GHADiscountRuleAccountType },
): CreateGHADiscountRuleBody {
  const body: CreateGHADiscountRuleBody = {
    propertyId: form.propertyId.trim(),
    accountType: form.accountType,
    discountType: form.discountType,
    discountValue: Number(form.discountValue),
    minAdvanceBookingWindow: Number(form.minAdvanceBookingWindow),
    minLengthOfStay: Number(form.minLengthOfStay),
  };

  return body;
}

export function formatDiscountAccountType(value: string) {
  return GHA_DISCOUNT_ACCOUNT_TYPE_OPTIONS.find((option) => option.value === value)?.label ?? value;
}

export function formatDiscountType(value: GHADiscountRuleDiscountType) {
  switch (value) {
    case 'percentage':
      return 'Percentage';
    case 'margin_retention':
      return 'Margin retention';
    default:
      return value;
  }
}

export function formatRuleDiscount(rule: GHADiscountRule) {
  if (rule.discountType === 'margin_retention') {
    return `Retain ${rule.discountValue}% margin`;
  }
  return `${rule.discountValue}% off`;
}

export function formatDateTime(value?: string | null) {
  return value ? formatDateWithClock(value) : '-';
}
